import sp1 from "../../../media/apartment/springlake/studio/studio1.jpg";
import sp2 from "../../../media/apartment/springlake/studio/studio2.png";
import sp3 from "../../../media/apartment/springlake/studio/studio3.png";
import sp4 from "../../../media/apartment/springlake/studio/studio4.png";
import sp5 from "../../../media/apartment/springlake/studio/studio5.png";

const apartspimages = [sp1, sp2, sp3, sp4, sp5];

export default apartspimages;
